/* eslint-disable prettier/prettier */
/* eslint-disable no-lonely-if */
import React, { useState, useMemo } from "react";
import { Box, TableCell, TableRow, Checkbox } from "@mui/material";
import PropTypes from "prop-types";

import { useSelector } from "react-redux";
import Styles from "./Styles";
import rowsStyle from "../styles";
import { ALL_MEMBERS } from "../../../contants/table/markAttendance";
import InputField from "../../../components/common/new/InputField/InputField";
import Table from "../../../components/common/new/Table/Table";
import DeleteIcon from "../../../assets/svg/DeleteIcon";
import PlusIcon from "../../../assets/svg/PlusIcon";
import { selectAttendanceMeetingType } from "../../../redux/selectors/attendance";
import { getKey } from "../../../utils/helper";
import { selectAllSIUsers } from "../../../redux/selectors/user";
import AlertForMobile from "../../../components/common/new/Alert/AlertForMobile";

const tabelCellWidth = {
  tiny: { maxWidth: "3.5rem" },
  small: { maxWidth: "6rem" },
  custom: { maxWidth: "7rem" },
  medium: { maxWidth: "10rem" },
};

// ✅ Meeting type mapping (raw -> user-friendly) - SAME AS DESKTOP
const formatMeetingTypeLabel = (type) => {
  const map = {
    DISCUSSION_MEETING: "Discussion Meeting",
    GOSHO_MEETING: "Gosho Meeting",

    OTHER_MEETING_CUBS_DIVISION: "Cubs Division Meeting",
    OTHER_MEETING_YOUNG_PHOENIX: "Young Phoenix Meeting",
    OTHER_MEETING_YOUNG_LION: "Young Lion Meeting",
    OTHER_MEETING_STUDENT_DIVISION: "Student Division Meeting",
    OTHER_MEETING_CAMPUS_GROUP: "Campus Group Meeting",
    OTHER_MEETING_EDUCATION_DIVISION: "Education Division Meeting",
    OTHER_MEETING_ARTS_DIVISION: "Arts Division Meeting",
    OTHER_MEETING_NEW_FRIENDS: "New Friends Meeting",
    OTHER_MEETING_HEALTHCARE_DIVISION: "Healthcare Division Meeting",
    OTHER_MEETING_MD_PILLAR: "MD Pillar Meeting",
    OTHER_MEETING_SOURCE_OF_ORIGIN: "Source of Origin Meeting",
  };

  if (!type) return "-";
  return map[type] || type.replaceAll("_", " ");
};

const getRows = (
  data,
  attendanceList,
  onCheckHandler,
  excludeMainlinePosition,
  title,
  isNewFriendsTable,
  deleteAppointmentHandler,
  selectedMeetingType,
  isArchive,
  selectMeetingType, // ✅ pass-in from parent
  isRegionSi // ✅ pass-in from parent
) => {
  const getBlockName = (item) => {
    if (excludeMainlinePosition) return item.blockName || "-";
    return item?.mainlinePositionName || item.blockName || "-";
  };

  return data?.map((friendInfo, index) => {
    const getCustomDivisionName = () => {
      if (selectedMeetingType?.includes("CUBS_MEETING")) return "Cubs";
      if (selectedMeetingType?.includes("YP_MEETING")) return "Young Phoenix";
      if (selectedMeetingType?.includes("YL_MEETING")) return "Young Lions";
      if (selectedMeetingType?.includes("SD_MEETING")) return "Student";
      return selectedMeetingType || "-";
    };

    const isLeader = friendInfo.meetingType === "LEADER";
    const isChecked = isLeader
      ? attendanceList.includes(`${friendInfo[getKey(friendInfo)]}-L`)
      : attendanceList.includes(friendInfo[getKey(friendInfo)]);

    // ✅ "Added via ..." label (only for Other Meeting screen + New Friends table)
    const addedViaType =
      friendInfo.originalMeetingType || friendInfo.meetingType;
    const addedViaLabel = formatMeetingTypeLabel(addedViaType);

    // ==================== SAME LOGIC AS DESKTOP ====================
    const isExactMeetingMatch =
      friendInfo.originalMeetingType === selectMeetingType;

    const isCrossMeetingType =
      isNewFriendsTable && selectMeetingType !== friendInfo.originalMeetingType;

    let isCheckboxDisabled;
    let shouldShowDeleteIcon;
    let shouldBeChecked;

    if (isNewFriendsTable) {
      if (isExactMeetingMatch) {
        // CASE 1
        isCheckboxDisabled = true;
        shouldShowDeleteIcon = !isArchive;
        shouldBeChecked = true;
      } else {
        if (friendInfo.otherMeetingType?.includes(selectMeetingType)) {
          // CASE 2
          isCheckboxDisabled = isArchive;
          shouldShowDeleteIcon = false;
          shouldBeChecked = isChecked;
        } else if (isCrossMeetingType) {
          // CASE 3
          isCheckboxDisabled = isArchive;
          shouldShowDeleteIcon = false;
          shouldBeChecked = isChecked;
        } else {
          // CASE 4
          isCheckboxDisabled = true;
          shouldShowDeleteIcon = !isArchive;
          shouldBeChecked = true;
        }
      }
    } else {
      isCheckboxDisabled = friendInfo.immutable === true || isArchive;
      shouldShowDeleteIcon = false;
      shouldBeChecked = isChecked;
    }
    // ==================== END LOGIC ====================

    return (
      <TableRow key={friendInfo[getKey(friendInfo)] || index}>
        <TableCell
          style={{ ...rowsStyle.paddingvertical, ...tabelCellWidth.tiny }}
        >
          {index + 1}
        </TableCell>

        {/* ✅ checkbox + delete in separate tiny cell (mobile layout) */}
        <TableCell
          style={{
            ...rowsStyle.paddingvertical,
            ...tabelCellWidth.tiny,
            paddingLeft: "0px",
          }}
        >
          <div
            style={
              !isArchive
                ? { display: "flex", alignItems: "center", gap: "2px" }
                : {
                    display: "flex",
                    justifyContent: "center",
                    marginRight: "16px",
                  }
            }
          >
            <Checkbox
              onChange={(e) => onCheckHandler(e, friendInfo)}
              checked={shouldBeChecked}
              disabled={isCheckboxDisabled}
              sx={{
                "&.Mui-checked": { color: "#0BAB5E" },
                "&.Mui-disabled": { color: "#bdbdbd" },
                "&.Mui-checked.Mui-disabled": { color: "#bdbdbd" },
                color: isCheckboxDisabled ? "#bdbdbd" : "#666",
              }}
            />

            {isNewFriendsTable && !isArchive && shouldShowDeleteIcon && (
              <Box
                style={{ cursor: "pointer" }}
                onClick={() => deleteAppointmentHandler(friendInfo.friendId)}
              >
                <DeleteIcon />
              </Box>
            )}
          </div>
        </TableCell>

        {/* ✅ Name cell */}
        <TableCell
          style={{ ...rowsStyle.paddingvertical, ...tabelCellWidth.custom }}
        >
          <Box style={rowsStyle.profileImgContainer}>
            <Box>
              {friendInfo.fullName}

              {/* ✅ Added via + mobileNumber only when Other Meeting screen + New Friends table */}
              {isNewFriendsTable && (
                <>
                  <Box
                    component="div"
                    sx={{
                      color: "#9e9e9e",
                      fontSize: "12px",
                      lineHeight: 1.2,
                      mt: "2px",
                    }}
                  >
                    Added via {`"${addedViaLabel}"`}
                  </Box>

                  {!!friendInfo.mobileNumber && (
                    <Box
                      component="div"
                      sx={{
                        color: "#9e9e9e",
                        fontSize: "12px",
                        lineHeight: 1.2,
                        mt: "2px",
                      }}
                    >
                      {friendInfo.mobileNumber}
                    </Box>
                  )}
                </>
              )}

              {title === ALL_MEMBERS && friendInfo?.mainlinePositionName && (
                <span>
                  <br />
                  <small>({friendInfo?.mainlinePositionName})</small>
                </span>
              )}
            </Box>
          </Box>
        </TableCell>

        <TableCell
          style={{ ...rowsStyle.paddingvertical, ...tabelCellWidth.small }}
        >
          {isRegionSi
            ? getCustomDivisionName(selectedMeetingType)
            : friendInfo.divisionName || "-"}{" "}
        </TableCell>

        <TableCell
          style={{ ...rowsStyle.paddingvertical, ...tabelCellWidth.small }}
        >
          {getBlockName(friendInfo)}{" "}
        </TableCell>

        {title === "Friends" && (
          <TableCell
            style={{ ...rowsStyle.paddingvertical, ...tabelCellWidth.small }}
          >
            {friendInfo.presentCount ?? 1}
          </TableCell>
        )}
      </TableRow>
    );
  });
};

function MarkAttendanceComponentForMobile({
  columns,
  rowsData,
  onCheckHandler,
  title,
  isNewFriendsTable = false,
  handleDelete,
  attendanceList,
  selectedMeetingType,
  isArchive,
  showAddButton = false,
  onAddNewFriendClick,
}) {
  const [searchQuery, setSearchQuery] = useState("");
  const [openDeleteAlert, setOpenDeleteAlert] = useState(false);
  const [selectedFriendId, setSelectedFriendId] = useState(null);
  const excludeMainlinePosition = title === ALL_MEMBERS;

  // ✅ same pattern as desktop: get selectors in component, pass to getRows
  const selectMeetingType = useSelector(selectAttendanceMeetingType);
  const { isRegionSi } = useSelector(selectAllSIUsers);

  const toggleDeleteAlert = () => {
    setOpenDeleteAlert(false);
    setSelectedFriendId(null);
  };

  const deleteAppointmentHandler = (friendId) => {
    setSelectedFriendId(friendId);
    setOpenDeleteAlert(true);
  };

  const onSubmitDelete = () => {
    handleDelete(selectedFriendId);
    setTimeout(toggleDeleteAlert, 1000);
  };

  const onQueryChange = (e) => {
    const query = e.target.value;
    setSearchQuery(query);
  };

  const filterRows = useMemo(() => {
    if (searchQuery?.length) {
      return rowsData.filter((row) =>
        row.fullName.toLowerCase().includes(searchQuery.toLowerCase())
      );
    }
    return rowsData;
  }, [searchQuery, rowsData]);

  return (
    <div>
      <Box
        sx={{
          ...Styles.CompContainer,
          minHeight: "90px",
          overflowY: "scroll",
        }}
      >
        <Box sx={Styles.titleContainer}>{title}</Box>
        <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
          {showAddButton && (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "4px",
                cursor: "pointer",
                color: "#1976d2",
                fontSize: "13px",
                fontWeight: 500,
                whiteSpace: "nowrap",
                "&:hover": { opacity: 0.8 },
              }}
              onClick={onAddNewFriendClick}
            >
              <PlusIcon /> Add New Friend
            </Box>
          )}

          <Box sx={Styles.OutlinInput}>
            <InputField
              placeholder="Search"
              inputProps={{
                style: {
                  input: {
                    "& .MuiInputBase-input::placeholder": {
                      textOverflow: "ellipsis !important",
                      color: "#183053",
                      opacity: 1,
                    },
                  },
                },
              }}
              value={searchQuery}
              onChange={onQueryChange}
            />
          </Box>
        </Box>
      </Box>

      <Box width="100%">
        <Table
          columns={columns}
          rows={getRows(
            filterRows,
            attendanceList,
            onCheckHandler,
            excludeMainlinePosition,
            title,
            isNewFriendsTable,
            deleteAppointmentHandler,
            selectedMeetingType,
            isArchive,
            selectMeetingType,
            isRegionSi
          )}
          tableBodyTheme="#F6F6F6"
          tableHeadCellStyle={{
            ...Styles.tableHeadCells,
            textAlign: "left",
          }}
          scrollable
        />

        <AlertForMobile
          open={openDeleteAlert}
          onClose={toggleDeleteAlert}
          onSubmit={onSubmitDelete}
        />
      </Box>
    </div>
  );
}

const propTypes = {
  columns: PropTypes.arrayOf(PropTypes.objectOf()).isRequired,
  rowsData: PropTypes.arrayOf(PropTypes.objectOf()).isRequired,
  attendanceList: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  ).isRequired,
  title: PropTypes.string.isRequired,
  isNewFriendsTable: PropTypes.bool,
  onCheckHandler: PropTypes.func,
  handleDelete: PropTypes.func.isRequired,
  selectedMeetingType: PropTypes.string.isRequired,
  isArchive: PropTypes.bool.isRequired,
  showAddButton: PropTypes.bool,
  onAddNewFriendClick: PropTypes.func,
};

const defaultProps = {
  onCheckHandler: () => {},
  isNewFriendsTable: false,
  showAddButton: false,
  onAddNewFriendClick: () => {},
};

MarkAttendanceComponentForMobile.propTypes = propTypes;
MarkAttendanceComponentForMobile.defaultProps = defaultProps;

export default MarkAttendanceComponentForMobile;
